import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppShell } from "@/layout/AppShell";
import { AuthProvider } from "@/supabase/AuthContext";
import {
  ProtectedRoute,
  RedirectIfSignedIn,
} from "@/supabase/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DailySales from "@/pages/DailySales";
import Inventory from "@/pages/Inventory";
import NebimImport from "@/pages/NebimImport";
import BesiktasInvoices from "@/pages/BesiktasInvoices";
import ProductMatching from "@/pages/ProductMatching";
import DataControl from "@/pages/DataControl";
import AIAnalysis from "@/pages/AIAnalysis";
import Expenses from "@/pages/Expenses";
import CurrentAccounts from "@/pages/CurrentAccounts";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/giris"
            element={
              <RedirectIfSignedIn>
                <Login />
              </RedirectIfSignedIn>
            }
          />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/satislar" element={<DailySales />} />
              <Route path="/stok" element={<Inventory />} />
              <Route path="/ice-aktarma/nebim" element={<NebimImport />} />
              <Route
                path="/ice-aktarma/besiktas"
                element={<BesiktasInvoices />}
              />
              <Route path="/urun-eslestirme" element={<ProductMatching />} />
              <Route path="/veri-kontrol" element={<DataControl />} />
              <Route path="/ai" element={<AIAnalysis />} />
              <Route path="/giderler" element={<Expenses />} />
              <Route path="/cari-hareketler" element={<CurrentAccounts />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
